<template>
    <section class="mb-20">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <NsServiceCard v-for="(feature, index) in features" :key="index" :image="feature.image"
                :title="feature.title" :description="feature.description" />
        </div>
    </section>
</template>

<script setup lang="ts">
const NsServiceCard = defineAsyncComponent(() => import('~/components/NsServiceCard.vue'))

const features = [
    {
        title: "Payment Gateway Integration",
        description:
            "Accept payments securely and effortlessly. Our store supports multiple payment gateways, ensuring customers have flexible and safe payment options.",
        image: "/images/services-section/payment-gateway.png",
    },
    {
        title: "Banners",
        description:
            "Create visually appealing promotional banners to highlight discounts, new arrivals, and featured products. Boost conversions with engaging customer experiences.",
        image: "/images/services-section/banners.png",
    },
    {
        title: "Filtering",
        description:
            "Enhance product discovery with advanced filtering options. Customers can search and sort products by categories, price, ratings, and more for a seamless shopping journey.",
        image: "/images/services-section/filter.png",
    },
    {
        title: "Customer Review Component",
        description:
            "Showcase customer feedback with our built-in review system. Integrate seamlessly with third-party platforms to display authentic reviews, building trust and credibility.",
        image: "/images/services-section/customer-review.png",
    },
    {
        title: "Wishlist",
        description:
            "Empower customers to save their favorite products for later with our wishlist feature. Enhance user experience and drive repeat visits to your store.",
        image: "/images/services-section/wishlist.png",
    },
    {
        title: "Multi-Language Support",
        description:
            "Reach a global audience with multi-language functionality. Easily localize your store to cater to customers from different regions and enhance their shopping experience.",
        image: "/images/services-section/multi-language.png",
    },
    {
        title: "Multi-Vendor",
        description:
            "Enable a marketplace setup with our multi-vendor support. Allow multiple vendors to sell their products through your store, expanding product variety and customer reach.",
        image: "/images/services-section/multi-vendor.png",
    },
    {
        title: "Multi-Store",
        description:
            "Run multiple stores with unique branding and inventory, all from a single backend. Perfect for businesses managing diverse product lines or targeting different markets.",
        image: "/images/services-section/multi-store.png",
    },
]
</script>
